// src/components/constants/Layout.js

import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useMsal } from "@azure/msal-react";

export const Layout = ({ isAuthenticated, setsidebor,Emp_Role }) => {
  const { instance } = useMsal();
  const activeAccount = instance?.getActiveAccount();
  const name = activeAccount?.name || sessionStorage.getItem("UserName").split("@")[0].toUpperCase();

  const initials = name?.split(" ").map(n => n[0]).join("").toUpperCase();

  const Name = sessionStorage?.getItem("UserName")?.charAt(0)?.toUpperCase();

  const [isSignOutVisible, setIsSignOutVisible] = useState(false);

  const toggleSignOut = () => {
    setIsSignOutVisible(!isSignOutVisible);
  };


  const handleSignOut = () => {


    console.log(isAuthenticated,"TTTTTTTT")

    if (isAuthenticated) {
      instance.logoutRedirect();
      localStorage.clear();
    }
    else {
      handleSignOutGoogle()

    }

  };
  const handleSignOutGoogle = () => {
    const token = localStorage.getItem("google_token");

    if (token) {
      fetch(`https://oauth2.googleapis.com/revoke?token=${token}`, {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        }
      });
    }

    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };




  return (
    <div className="flex h-screen">
      <Sidebar Emp_role={Emp_Role} setsidebor={setsidebor} />
      <main className="flex-1 min-w-0 py-10 px-3 relative bg-gray-100">
        <Header
          user_name={name}
          initials={initials || Name}
          toggleSignOut={toggleSignOut}
          isSignOutVisible={isSignOutVisible}
          handleSignOut={handleSignOut}
          Emp_role={Emp_Role}
        />
        <Outlet />
      </main>
    </div>
  );
};
